import { Category, CategoryKeys, SYSTEM_WIDE_OUTAGE } from "../model";

export function extractCategoryAndSubcategory(categoryString: string) {
  const categoryKey = categoryString.includes(SYSTEM_WIDE_OUTAGE)
    ? SYSTEM_WIDE_OUTAGE
    : (categoryString.split(" ")[0] as CategoryKeys);
  const category = Category[categoryKey];

  // If it is System Wide Outage file, do not add subcategory. If not, get subcategory by removing category from file name
  const subcategory = categoryString.includes(SYSTEM_WIDE_OUTAGE)
    ? undefined
    : categoryString.replace(categoryKey, "").trim();

  return { category, subcategory };
}
